import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PdfModalComponent } from './components/pdf-modal/pdf-modal.component';

@Component({
  selector: 'app-communication-attachment',
  templateUrl: './communication-attachment.component.html',
  styleUrls: ['./communication-attachment.component.scss']
})
export class CommunicationAttachmentComponent implements OnInit{

  @Input() attachment!: Attachment;

  constructor(private dialog: MatDialog ) {}

  ngOnInit(): void {
    if (!this.attachment) {
      throw new Error ("Attachment data is required");
    }
  }

  open() {

    switch (this.attachment.type) {
      case 'SECRET_PDF': 
        this.dialog.open(PdfModalComponent, {data: this.attachment})
      break;

      default:
        throw new Error("Unsupported attachment type: "+this.attachment.type)
    }

  }


}


export interface Attachment {
  name:string,
  path?:string,
  value?: string,
  type: 'SECRET_PDF'
}
